import { OreButton, OreHeading, OreStack, OreText } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { loginSiteUrl } from '@/Shared/infrastructure'
import RedLogo from '@/Shared/ui/assets/red-logo.svg'
import { PageWrapper } from '@/Shared/ui/layout'

import { deleteAccountTranslation } from '../userTranslation'

export const DeleteAccountSuccessPage = (): JSX.Element => {
  const { t } = useTranslation()

  const redirectToLogin = (): void => {
    sessionStorage.clear()
    localStorage.clear()
    window.location.href = loginSiteUrl
  }

  return (
    <PageWrapper paddingSmaller>
      <OreStack placeContent="center" placeItems="center" space="2xlarge">
        <img src={RedLogo} alt="" />
        <OreStack space="large">
          <OreHeading as="h1" size="title-sm" align="center">
            {t(deleteAccountTranslation.modal.successTitle)}
          </OreHeading>

          <OreText size="text-sm" align="center">
            {t(deleteAccountTranslation.modal.successDescription)}
          </OreText>
          <OreStack placeContent="center">
            <OreButton
              as="button"
              category="primary"
              onClick={redirectToLogin}
              size="large"
            >
              {t(deleteAccountTranslation.modal.successButton)}
            </OreButton>
          </OreStack>
        </OreStack>
      </OreStack>
    </PageWrapper>
  )
}
